export default "__VITE_ASSET__BR53aq$v__"